/* jshint esversion: 6 */
/* jshint ignore:start */
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import AppleIcon from "../assets/Image/AppLogo.png";
import PlaystoreIcon from "../assets/Image/Playstore.png";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../assets/Image/Logo.png";
import secureLocalStorage from "react-secure-storage";
import { buildImageUrl } from "../utils/image";

const PLAY_STORE_URL =
    process.env.REACT_APP_PLAY_STORE_URL ||
    "https://play.google.com/store/apps/details?id=com.rapidmedik.customerapp1";
// No iOS build is published yet; set REACT_APP_APP_STORE_URL to switch the badge on.
const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || "";

const Footer = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, setActivePage, siteLogo, siteTitle } = useContext(MyContext);

    const [pageList, setPageList] = useState([]);
    const navigate = useNavigate();
    const savedLogo = siteLogo || secureLocalStorage.getItem("site_logo");
    const brandLogo = savedLogo ? buildImageUrl(ImgBaseUrl, savedLogo, "default") : Logo;
    const brandTitle = siteTitle || "RapidMediK";

    useEffect(() => {
        axios.post(`${ApiBaseUrl}/customer/pages`)
            .then((res) => {
                // console.log("/customer/pages", res);
                setPageList(res.data.pages_data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const HandleNavigate = (path, id) => {
        setActivePage(id);
        navigate(`/${path}`, { state: true });
    };

    const HandleOpenLink = (Link) => {
        window.open(Link, "blank");
    }

    return (
        <div className='bg-rm-ink rounded-t-[30px] p-[20px] md:p-[35px]'>
            <div className="bg-white rounded-[30px] p-[20px] md:p-[25px]">
                <div className="flex flex-col md:flex-row items-start justify-between gap-[20px] pt-[20px]">
                    <div className="">
                        <Link to="/" className="flex items-center gap-[10px]">
                            <img
                                src={brandLogo}
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = Logo;
                                }}
                                className="w-[52px] h-[52px] object-contain"
                                alt="RapidMediK"
                            />
                            <h1 className='font-extrabold text-[22px] sm:text-[28px] tracking-tight text-rm-ink'>{brandTitle}</h1>
                        </Link>
                        <p className='text-[16px] mt-[24px] text-rm-muted max-w-xl leading-relaxed'>{t("A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,")} {t("managing, and attending doctor's appointments.")}</p>
                    </div>
                    <div className="flex items-center gap-[12px]">
                        {[FaFacebookF, FaTwitter, FaInstagram, FaYoutube].map((Icon, idx) => (
                            <div key={idx} className="bg-orange-50 p-[10px] rounded-full group cursor-pointer hover:bg-rm-primary transition-colors">
                                <Icon className='text-[18px] text-rm-deep group-hover:text-white' />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex flex-col md:flex-row md:items-center justify-between gap-[16px] my-[20px] p-[16px] bg-gray-50 rounded-[20px]">
                    <div>
                        <h2 className="font-semibold text-[15px] text-rm-ink">24/7 Support</h2>
                        <div className="flex flex-wrap items-center gap-x-[16px] gap-y-[4px] mt-[4px] text-[14px] text-rm-muted">
                            <a href="tel:+919429694496" className="hover:text-rm-primary font-medium">+91 94296 94496</a>
                            <a href="mailto:care@rapidmedik.in" className="hover:text-rm-primary font-medium">care@rapidmedik.in</a>
                        </div>
                    </div>
                    <div className="text-[13px] text-rm-muted md:text-right leading-relaxed">
                        <p>Serving Hyderabad &amp; Secunderabad</p>
                        <p>UPI, cards, net banking via Cashfree. We do not store card numbers.</p>
                    </div>
                </div>

                <div className="flex flex-wrap items-center gap-[20px] my-[20px]">
                    <Link to="/subscription" className="font-[500] text-[16px] hover:text-rm-primary">Membership</Link>
                    <Link to="/health-records" className="font-[500] text-[16px] hover:text-rm-primary">Health Records</Link>
                    <Link to="/equipment-rental" className="font-[500] text-[16px] hover:text-rm-primary">Equipment Rental</Link>
                    <Link to="/home-care" className="font-[500] text-[16px] hover:text-rm-primary">Home Care</Link>
                    <Link to="/pay-app" className="font-[500] text-[16px] hover:text-rm-primary">Pay via App</Link>
                    <Link to="/corporate" className="font-[500] text-[16px] hover:text-rm-primary">For Business</Link>
                    <Link to="/faq" className="font-[500] text-[16px] hover:text-rm-primary">FAQ</Link>
                    {pageList.map((item, index) => {
                        const Title = item.title.replace(/\s+/g, '_');
                        const FinalText = Title.toLowerCase();

                        return <div onClick={() => HandleNavigate(`${FinalText}`, (index + 8))} key={index} className="cursor-pointer group">
                            <h1 className="font-[500] text-[16px] group-hover:text-gray-700">{item.title}</h1>
                        </div>
                    })}
                </div>

                <div className="flex flex-col md:flex-row items-center justify-between gap-[20px] pt-[20px] border-t-[1px]">
                    <h1>{t("@ Powered By RapidMediK")}</h1>
                    <div className="flex flex-wrap items-center gap-[10px]">
                        <button
                            onClick={() => HandleOpenLink(PLAY_STORE_URL)}
                            aria-label="Get RapidMediK on Google Play"
                        >
                            <img src={PlaystoreIcon} className='w-[130px] md:w-[150px] cursor-pointer' alt="Get it on Google Play" />
                        </button>
                        {APP_STORE_URL ? (
                            <button onClick={() => HandleOpenLink(APP_STORE_URL)} aria-label="Get RapidMediK on the App Store">
                                <img src={AppleIcon} className='w-[130px] md:w-[150px] cursor-pointer' alt="Download on the App Store" />
                            </button>
                        ) : (
                            <div className="relative" title="The iPhone app is on its way.">
                                <img src={AppleIcon} className='w-[130px] md:w-[150px] opacity-40 grayscale' alt="" />
                                <span className="absolute inset-0 flex items-center justify-center text-[11px] font-[700] text-rm-ink">
                                    iOS coming soon
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
/* jshint ignore:end */